import L from "leaflet";

export function ContextMenuItem(title, action, separator = false) {
    return {
        title,
        action,
        separator
    }
}

export class ContextMenu {
    lastContextMenu = null;
    
    static closeContextMenu() {
        try {
            if (ContextMenu.lastContextMenu) {
                // close previous context menu
                document.body.removeChild(ContextMenu.lastContextMenu);
            }
        }
        catch(e) {
            console.error(e);
        }

        ContextMenu.lastContextMenu = null;
    }

    static contextMenuHandler(config) {
        this.closeContextMenu();
        
        const {
            x,
            y,
            items = []
        } = config;

        const contextMenu = ContextMenu.lastContextMenu = L.DomUtil.create('div', 'context-menu');
        const separatorBorder = '1px solid #bbb';
        contextMenu.style.position = 'absolute';
        contextMenu.style.zIndex = '1000';
        contextMenu.style.backgroundColor = 'white';
        contextMenu.style.border = '1px solid #ccc';
        contextMenu.style.padding = '5px';
        contextMenu.style.borderRadius = '3px';
        contextMenu.style.boxShadow = '0 0 5px rgba(0,0,0,0.2)';
        contextMenu.style.left = `${x}px`;
        contextMenu.style.top = `${y}px`;     
        
        items.filter(Boolean).forEach(item => {
            const option = L.DomUtil.create('div', 'context-menu-item', contextMenu);
            option.innerHTML = item.title;
            option.style.cursor = 'pointer';
            option.style.padding = '3px 10px';

            if (item.separator)
                option.style.borderBottom = separatorBorder; 

            L.DomEvent.on(option, 'click', (e) => {
                e.preventDefault();
                L.DomEvent.stopPropagation(e);                
                ContextMenu.closeContextMenu();
                item.action();
            });
        });
        


        document.body.appendChild(contextMenu);

        const closeMenu = (e) => {
            if (!contextMenu.contains(e.target)) {
                e.preventDefault();
                L.DomEvent.stopPropagation(e);                
                ContextMenu.closeContextMenu();
                document.removeEventListener('click', closeMenu);
            }
        };

        setTimeout(() => {
            document.addEventListener('click', closeMenu);
        }, 0);


        return contextMenu;
    }
}